import { render, staticRenderFns } from "./House.vue?vue&type=template&id=0554334d&scoped=true&"
import script from "./House.vue?vue&type=script&lang=js&"
export * from "./House.vue?vue&type=script&lang=js&"
import style0 from "./House.vue?vue&type=style&index=0&id=0554334d&lang=less&scoped=true&"
import style1 from "./House.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0554334d",
  null
  
)

export default component.exports